import { useState } from 'react';
import type { Route } from '@shared/model/dataset';
import { Alert } from '../components/Alert';
import { TrailMap } from '../components/LazyTrailMap';
import { TrailsTable } from '../components/TrailsTable';
import { useDataset } from '../hooks/useDataset';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { pageTitle, type PageConfig } from '../site';
import styles from './TrailsPage.module.css';

interface Props {
    page: PageConfig;
}

export function TrailsPage({ page }: Props) {
    const { dataset, status, error } = useDataset();
    const [selected, setSelected] = useState<string | null>(null);
    useDocumentTitle(pageTitle(page));

    return (
        <div className="container container--medium" id="sentiers">
            <h2 className={styles.title}>Tous les sentiers de la Réunion</h2>
            <TrailMap
                center={page.center}
                zoom={page.zoom}
                showAllRoutes
                showAllPoints={false}
                highlightRouteId={selected}
                className={styles.map}
            />
            {status === 'error' && <Alert level="danger">Impossible de charger les sentiers : {error}</Alert>}
            {status === 'loading' && <Alert spinner>Chargement des sentiers…</Alert>}
            {dataset && (
                <TrailsTable
                    dataset={dataset}
                    selectedRouteId={selected}
                    onSelect={(route: Route) => setSelected(route.id)}
                />
            )}
        </div>
    );
}
